module.exports = __webpack_public_path__ + "1_0_62/img/ios-button.b4a1e6ac.png";